import img404 from '../Assets/PageNotFound.jpg';
const Page404 = ()=>{
    return <div className='flex flex-row items-center justify-center min-h-screen dark:bg-secondary-dark lg:px-8 md:px-4 px-2'>
        <img alt = '404 page not found' src={img404} className=' object-cover '/>
    </div>
}

export default Page404